"use client";

import { QueryClient } from "@tanstack/react-query";

export function getQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retry: 3,
        retryDelay: 2000,
        staleTime: 1000 * 60 * 5,
      },
    },
  });
}
